import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import './index.css';

import "./App.css";
import "./V2_App.css";
import Login from "./component/Login";
import Home from "./component/Home";
import PrintOrder from "./component/PrintOrder";
// import PrintMiniOrder from './component/PrintMiniOrder';
import PrintMiniOrderV2 from "./component/PrintMiniOrderV2";
import PrintMiniOrderOld from "./component/PrintMiniOrderOld";
import PrintDelivery from "./component/PrintDelivery";
import ProductsCatalog from "./component/ProductsCatalog";
import PrintOrderDoc from "./component/PrintOrderDoc";
import PrintOrderProduct from "./component/PrintOrderProduct";
import Wholesaler from "./component/Wholesaler";
import PageNotFound from "./component/PageNotFound";
import PrintProduct from "./component/PrintProduct";
import CatalogEditor from "./component/CatalogEditor";
import Maintenance from "./component/Maintenance";

import V2_Wholesaler from "./component/page/V2_Wholesaler";
import { onValue, ref } from "./utilities/Firebase";
import { db } from "./utilities/Firebase";

const theme = createMuiTheme({
  typography: {
    fontFamily: 'Poppins, Arial, sans-serif',
  },
});

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maintenance: false,
      firebaseError: false,
      errorMessage: "",
    };
  }

  componentDidMount() {
    if (process.env.NODE_ENV === "development") {
      console.debug("Application initialized in development mode");
    }

    try {
      const maintenanceRef = ref(db, "/grosir");

      onValue(
        maintenanceRef,
        (snapshot) => {
          if (snapshot.exists()) {
            console.info("Maintenance data received");
            console.log(snapshot.val());
            this.setState({ maintenance: snapshot.val() });
          } else {
            console.warn("No maintenance data found at /grosir");
          }
        },
        (error) => {
          console.error("Firebase read failed:", error.message);
          this.setState({
            firebaseError: true,
            errorMessage: error.message || "Failed to connect to Firebase",
          });
        }
      );
    } catch (error) {
      console.error("Error setting up Firebase listener:", error.message);
      this.setState({
        firebaseError: true,
        errorMessage: error.message || "Failed to initialize Firebase",
      });
    }
  }

  render() {
    return this.state.maintenance ? (
      <Maintenance />
    ) : (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <div>
            <Route path="/v2_wholesaler/" component={V2_Wholesaler} />

            <Route exact path="/login/" component={Login} />
            <Route exact path="/catalog_editor/" component={CatalogEditor} />
            <Route exact path="/login/:random" component={PageNotFound} />
            <Route exact path="/gphome/:page_id" component={Home} />
            <Route exact path="/gphome/" component={Home} />
            <Route exact path="/print_mini/:data" component={PrintMiniOrderV2} />
            <Route exact path="/print_rekap_order/:data" component={PrintOrderDoc} />
            <Route exact path="/print_rekap_order/" component={PageNotFound} />
            <Route exact path="/print_rekap_order_product/:data" component={PrintOrderProduct} />
            <Route exact path="/print_rekap_order_product/" component={PageNotFound} />
            <Route exact path="/print_mini/" component={PageNotFound} />

            <Route
              exact
              path="/print_mini_old/:data"
              component={PrintMiniOrderOld}
            />
            <Route exact path="/print_mini_old/" component={PageNotFound} />

            <Route exact path="/print/:data" component={PrintOrder} />
            <Route exact path="/print/" component={PageNotFound} />
            <Route exact path="/print_delivery/:data" component={PrintDelivery} />
            <Route exact path="/print_delivery/" component={PageNotFound} />
            <Route exact path="/print_product/:data" component={PrintProduct} />
            <Route exact path="/print_product/" component={PageNotFound} />
            <Route exact path="/products_catalog/" component={ProductsCatalog} />
            <Route
              exact
              path="/products_catalog/:random"
              render={() => <PageNotFound is_null={true} />}
            />
            <Route path="/:session" component={Wholesaler} />
            <Route exact path="/" component={Wholesaler} />
          </div>
        </Router>
      </ThemeProvider>
    );
  }
}
